import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import _ from 'lodash';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import moment from 'moment';
import { useAuth } from '../../hooks/useAuth';
const AwardedPointDetail = (props) => {
    const [data, setData] = useState();
    const { state } = useLocation();
    const { awardPointDetails } = state;
    const { getToken } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (state?.awardPoint_id) {
            getAwardedPointDetails(state?.awardPoint_id);
        }
    }, []);

    async function getAwardedPointDetails(id = '') {
        const authToken = getToken();
        if (authToken && id) {
            // new WebApiCalls().getSingleAwardPoint(JSON.parse(authToken), id)
            //     .then(res => { console.log(); })
            //     .catch(err => { })
        }
    }
    const handleBackClick = () => {
        navigate(-1); // Go back to the previous page
    };
    return (
        <>
            <Row className="justify-content-end align-items-center">
                <Col sm={4} md={3} className="text-center">
                    <Button onClick={handleBackClick} className="theme-cancel-btn px-5 py-2">
                        Close
                    </Button>
                </Col>
            </Row>
            <Row>
                {/* <Col sm={4}>
                    <div className="detail-heading ms-5">
                        Awarded Point Details
                    </div>
                </Col> */}
            </Row>
            <Row className="d-flex justify-content-center">
                <Col xs={12} sm={12} md={11} lg={11} className="p-4 m-3 ps-0 ms-0">
                    <Row>
                        <Col md={4}>
                            <div className="detail-small-heading">Transit Agency logo</div>
                            <img src={awardPointDetails?.transit_agency?.logo} className="img-fluid" width={150} alt="" />
                        </Col>
                        <Col md={4}>
                            <div className="detail-small-heading">Route Name</div>
                            <div className="detail-value">{awardPointDetails?.route?.name}</div>
                        </Col>

                        <Col md={4}>
                            <div className="detail-small-headingg">Commuters Name</div>
                            <div className="detail-value">{_.capitalize(awardPointDetails?.commuter?.name)}</div>
                        </Col>
                    </Row>

                    <Row className="mt-5">
                        <Col md={4}>
                            <div className="detail-small-heading">Distance Traveled</div>
                            <div className="detail-value">{awardPointDetails?.distance}</div>
                        </Col>

                        <Col md={4}>
                            <div className="detail-small-heading">GHG Emission Saved</div>
                            <div className="detail-value">{awardPointDetails?.ghg_saved}</div>
                        </Col>

                        <Col md={4}>
                            <div className="detail-small-heading">Points Awarded</div>
                            <div className="detail-value">{awardPointDetails?.points_earned}</div>
                        </Col>
                    </Row>

                    <Row className="mt-5">
                        <Col md={4}>
                            <div className="detail-small-heading">Time Stamp</div>
                            <div className="detail-value">
                                <span>{awardPointDetails?.date ? moment(awardPointDetails?.date).format('MM-DD-YYYY') : ''}</span>
                                <br />
                                <span>{awardPointDetails?.finished_at ? moment(awardPointDetails?.finished_at, 'hh:mm').format('hh:mm A') : ''}</span>
                            </div>
                        </Col>
                    </Row>

                    {/* <>
                        <hr className='mt-3' />
                        <Row className='mt-4'>
                            <Col md={4}>
                                <div className="detail-value">Vendor Listing</div>
                            </Col>
                        </Row>

                        <Row>
                            <DataTable
                                columns={vendorColumns}
                                data={vendorListing}
                                // selectableRows
                                responsive
                                // pagination
                                // paginationServer
                                // paginationTotalRows={totalRecords}
                                // onChangeRowsPerPage={handlePerRowsChange}
                                // onChangePage={handlePageChange}
                                // responsive
                                // direction="auto"
                                // fixedHeaderScrollHeight="300px"
                                // subHeaderAlign="right"
                                // subHeaderWrap
                                customStyles={customStyles}
                            // onSelectedRowsChange={handleRowSelected}
                            // clearSelectedRows={toggleCleared}
                            // defaultSortFieldId={1}
                            />
                        </Row> */}
                </Col>

                {/* <Row>
                <Col sm={4}>
                    <div className="detail-heading ms-5">
                        Awarded Point Details
                    </div>
                </Col>
                <Col sm={4} md={3} lg={2} className="text-end ms-auto">
                    <Link to="/users">
                        <Button className='theme-cancel px-5 py-2'>Close</Button>
                    </Link>
                </Col>
            </Row>
            <Row className="d-flex justify-content-center">
                <Col xs={12} sm={12} md={11} lg={11} className="m-3 ps-0 ms-0">
                    <Row>
                        <Col md={4}>
                            <div className='detail-small-heading'>Route Name</div>
                            <div className="detail-value">{data?.name ? "Route Name here" : "Route Name here"}</div>
                        </Col>

                        <Col md={4}>
                            <div className='detail-small-headingg'>Distance Traveled</div>
                            <div className="detail-value">{data?.email}</div>
                        </Col>


                        <Col md={4}>
                            <div className='detail-small-heading'>GHG Emissions Saved</div>
                            <div className="detail-value">{data?.phone_no}</div>
                        </Col>
                    </Row>

                    <Row className='mt-5'>
                        <Col md={4}>
                            <div className='detail-small-heading'>Points Awarded</div>
                            <div className="detail-value">{data?.gender}</div>
                        </Col>

                        <Col md={4}>
                            <div className='detail-small-heading'>Time stamp</div>
                            <div className="detail-value">{data?.dob}</div>
                        </Col>


                    </Row>
                </Col>
            </Row> */}
            </Row>
        </>
    );
};

export default AwardedPointDetail;
